module.exports = __webpack_public_path__ + "5874364d5ae80a8671d620d78ff9f1b5.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/opensans-regular/opensans-regular.ttf
// module id = ./src/styles/fonts/opensans-regular/opensans-regular.ttf
// module chunks = index